import { WhiteLabelThemeData } from "app/core/white-label/white-label.type";

export const NCONNECTVOICE_WHITELABEL_DATA: WhiteLabelThemeData = {
  productTitle: "NFON SIP Trunk",
  userProfileLink: "https://id.nfon.com",
  userManagementLink: "https://accounts.nfon.com",
  legalLinks: [
    {
      name: "imprint",
      url: "https://www.nfon.com/legal-notice/",
      e2e: "__imprint",
    },
    {
      name: "data_protection",
      url: "https://www.nfon.com/data-disclaimer/",
      e2e: "__data-protection",
    },
    {
      name: "gtc_sla",
      url: "https://www.nfon.com/gtc",
      e2e: "__terms-and-conditions",
    },
  ],
  login: {
    links: [
      {
        name: "Documentation",
        url: {
          default:
            "https://www.nfon.com/en/service/documentation/manuals/nconnect-voice-20",
          de: "https://www.nfon.com/de/service/dokumentation/handbuecher/nconnect-voice-20",
          en: "https://www.nfon.com/en/service/documentation/manuals/nconnect-voice-20",
          es: "https://www.nfon.com/es/service/documentation/manuales/nconnect-voice-20-manual",
          it: "https://www.nfon.com/it/service/documentation/manuali/nconnect-voice-20-manuale",
          pl: "https://www.nfon.com/pl/service/documentation/instrukcje/instrukcja-nconnect-voice-20",
        },
        e2e: "__documentation",
      },
    ],
    isHiddenReportingPortalUrl: true,
    isShowPortalMenu: true,
    productName: "Nconnect Voice",
  },
  logo: [
    {
      location: ["sidenav__footer", "auth-header", "insufficient-permissions"],
      name: "nconnect-voice-logo",
    },
  ],
  meetingPerUser: "Meet & Share Plus",
  nconnectVoiceProductName: "NFON SIP Trunk",
};
